import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NgOption } from '@ng-select/ng-select';
import { Subscription } from 'rxjs';
import { SharedConstants, User } from 'src/app/models';
import { AuthService } from 'src/app/Service/auth.service';
import { EventService } from 'src/app/Service/event.service';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { CookieService } from 'ngx-cookie-service';
import { TranslateService } from '@ngx-translate/core';
import { Menu, NAVIGATOR } from './models/shared/menu';
import { MenuItemService } from './modules/shared/menu-item/menu-item.service';
import { CountdownService } from './Service/countdown.service';
import { Role } from './models/shared/role';

declare let $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit, OnDestroy {
  private cookieService = inject(CookieService);
  public navBar: Array<Menu> = [];
  public navBarSecondary: Array<Menu> = [];

  currentUser: User;
  loading = false;
  loadingDataStarted: Subscription;
  loadingDataComplete: Subscription;
  logueado: boolean = true;

  roles: NgOption[];
  module: string;
  IconDown = faCaretDown;
  pathAssets: string;
  id: number;
  photo: string;
  name: string;
  companyName: string = "NOMBRE DE LA EMPRESA S.A. DE C.V.";
  //userIsSuperAdmin: boolean = false;


  //Menu
  public heighNavBar: string;
  //Menu language
  protected language: string;
  protected imgPath: string = "";

  constructor(private readonly router: Router,
    private readonly authService: AuthService,
    private readonly eventService: EventService,

    private readonly translate: TranslateService,
    private readonly sharedConstants: SharedConstants,

    private readonly menuItemService: MenuItemService,

    private readonly countdownService: CountdownService,) {

    this.setLanguaje();
    this.roles = this.sharedConstants.roles;
    this.authService.currentUser.subscribe(resp => {
      console.log("currentUser=>", resp);

      this.getCurrentUser(resp);
      if (resp) {
        //        this.getCurrentUser(resp);

        try {
          if (resp.roles) {
            resp.roleName = this.roles.find(i => i.valueLogin === resp.roles[0].rol) ?
              this.roles.find(i => i.valueLogin === resp.roles[0].rol).name : '';

            // if (resp.roles[0].id == EnumUserRol.SUPER_ADMIN) {
            //   this.userIsSuperAdmin = true;
            // }
            this.navBar = this.createMenu(resp.roles[0].rol);
          }
        } catch (ex) {
          console.error(ex);
        }

      }

      //this.getCurrentUser(resp);

    });
  }

  getCurrentUser(resp) {
    this.getLanguageMenu();
    if (resp === null || resp.username === undefined) {
      this.currentUser = null;
    }
    else {
      this.currentUser = resp;
      this.id = this.currentUser.id;
      this.name = this.currentUser.username;
      if (this.name == 'null')
        this.name = 'USUARIO NO IDENTIFICADO';
      localStorage.setItem("userId", this.currentUser.id.toString());
      this.photo = localStorage.getItem('photoUser');
    }
  }

  ngOnInit() {
    this.loading = (localStorage.getItem("startLoading") == "1");
    this.module = location.pathname.split('/')[1];
    this.loadingDataStarted = this.eventService.loadingDataStarted.subscribe(() => {
      setTimeout(() => {
        this.showSpinner();
      });
    });

    this.loadingDataComplete = this.eventService.loadingDataComplete.subscribe(() => {
      setTimeout(() => {
        this.hideSpinner();
      });
    });
    this.authService.onUpdateTabsCount();
    this.checkCountdowns();
  }


  private createMenu(userRol: string): Array<Menu> {
    let menu: Array<Menu>;

    // if (userRol == Role.RRHH) {
    //   menu = NAVIGATOR.RRHH;
    // }
    // else  if (userRol == Role.EXECUTIVE) {
    //   menu = NAVIGATOR.EXECUTIVE;
    // }
    // else {
    //   if (userRol == Role.Admin) {
    //     menu = NAVIGATOR.ADMIN;
    //     if (this.currentUser.sectionOtherDocuments) {
    //       let itemAdmin = menu.find(x => x.children);
    //       let itemMenu = itemAdmin.childrenContent.find(x => x.keyLg == "otherDocuments");
    //       itemMenu.show = true;
    //     }

    //     if (!this.currentUser.assistanceModule) {
    //       menu = menu.filter(x => x.keyLg != "rollCall");
    //     }

    //   }
    //   if (userRol == Role.SuperAdmin) {
    //     menu = NAVIGATOR.SUPERADMIN;
    //   }

    //   if (userRol == Role.Gestor) {
    //     menu = NAVIGATOR.USER;
    //   }

    //   menu = menu.concat(NAVIGATOR.SHARED);
    // }

    menu = NAVIGATOR.SHARED;

    menu.forEach(element => {
      this.translate.stream('menu.' + element.keyLg).subscribe((res: string) => {
        element.label = res;
        this.getLanguage(element);
      });

    });

    menu.sort((a, b) => { return a.order - b.order; });

    return menu;
  }

  getLanguage(element: Menu) {
    if (element.children) {
      element.childrenContent.forEach(elementChildren => {
        this.translate.stream('menu.' + elementChildren.keyLg).subscribe((res: string) => {
          elementChildren.label = res;
        });
      });
    }
  }

  private showSpinner() {
    this.loading = true;
  }

  private hideSpinner() {
    this.loading = false;
  }

  toggleSideBar() {
    $('#sidebar').addClass('active');
    $('.overlay').addClass('active');
    $('.collapse.in').toggleClass('in');
    $('a[aria-expanded=true]').attr('aria-expanded', 'false');
  }

  dismissSideBar() {

    $('#sidebar').removeClass('active');
    $('.overlay').removeClass('active');
  }

  logout() {
    //Antes de cerrar sesión se obtiene el valor de contador de tabs
    //se mantiene en sesión
    const newTabCount = localStorage.getItem('s_tabsOpen');
    console.log(newTabCount);

    //se limpia el resto de info pero se mantiene el valor de tabs
    this.logueado = false;
    localStorage.setItem('logueado', "0");
    localStorage.clear();

    this.authService.logout();

    this.router.navigate(['/login']);
    localStorage.setItem('s_tabsOpen', newTabCount);
    this.cookieService.set("s_tabsOpen", newTabCount);
    this.cookieService.delete("roleName");
    this.cookieService.delete("userId");

  }

  public onShowSecondaryNav(data: Menu) {
    if (data.children) {
      if (this.navBarSecondary.length > 0) {
        if (this.navBarSecondary == data.childrenContent) {
          this.navBarSecondary = [];
          return;
        }
      }
      this.navBarSecondary = data.childrenContent;
    } else {
      let valueSelect: number = (this.menuItemService.checkIfOrderIsAChild(data.order));
      this.menuItemService.setNavbarSelect(valueSelect);

      this.router.navigate([data.link]);
      this.navBarSecondary = [];
    }
  }


  ngOnDestroy() {
    if (this.loadingDataStarted) {
      this.loadingDataStarted.unsubscribe();
    }
    if (this.loadingDataComplete) {
      this.loadingDataComplete.unsubscribe();
    }
  }

  onValidateCookieUser() {

    let _old = this.cookieService.get('userId');
    let _check = this.cookieService.check('userId');
    //console.log('_check', _check);

    if (!_check) {
      this.logout();
    }
    //console.log('currentUser', this.currentUser.id);
    const newTabCount = localStorage.getItem('s_tabsOpen');
    //console.log('TabCount=', newTabCount);
    if (newTabCount == null) {
      this.logout();
    }
    else if (_old != this.currentUser.id.toString()) {
      console.log('Usuario actual dif');
      let oldDateObj = new Date();
      let newDateObj = new Date();
      newDateObj.setTime(oldDateObj.getTime() + (1 * 60 * 1000));
      //console.log(newDateObj);
      //this.cookieService.set('userId', this.currentUser.id.toString(), newDateObj);
      this.cookieService.set('userId', this.currentUser.id.toString());
      window.location.reload();
    }
  }



  setLanguaje() {
    let lang = localStorage.getItem('lang');

    if (lang) {
      this.translate.setDefaultLang(lang);
    }
    else {
      this.translate.setDefaultLang('es');
    }
  }

  /** Managment the all countdowns necessarys for each process, with this, if the user leave of the section, the countdown continue */
  private checkCountdowns(): void {
    /** For IMSS History service */
    let isNanImssTiempoRestante = isNaN(parseInt(localStorage.getItem(this.countdownService.imssNameCountdowmn)));
    if (!isNanImssTiempoRestante) {
      let tiempoRestanteLS = parseInt(localStorage.getItem(this.countdownService.imssNameCountdowmn));
      this.countdownService.startCountdown(tiempoRestanteLS, this.countdownService.imssNameCountdowmn);
    }
    /** For ISSSTE History service */
    let isNanIsssteTiempoRestante = isNaN(parseInt(localStorage.getItem(this.countdownService.isssteNameCountdowmn)));
    if (!isNanIsssteTiempoRestante) {
      let tiempoRestanteLS = parseInt(localStorage.getItem(this.countdownService.isssteNameCountdowmn));
      this.countdownService.startCountdown(tiempoRestanteLS, this.countdownService.isssteNameCountdowmn);
    }
    /** For NSS service */
    let isNanNssTiempoRestante = isNaN(parseInt(localStorage.getItem(this.countdownService.nssNameCountdowmn)));
    if (!isNanNssTiempoRestante) {
      let tiempoRestanteLS = parseInt(localStorage.getItem(this.countdownService.nssNameCountdowmn));
      this.countdownService.startCountdown(tiempoRestanteLS, this.countdownService.nssNameCountdowmn);
    }
  }




  private getLanguageMenu() {
    let _lng = localStorage.getItem("lang");
    this.language = _lng;
    console.log(_lng);
    if (_lng) {
      this.imgPath = "../assets/images/" + _lng + "_circle" + ".svg";
    }
  }

  protected onChangeMenu(parent: any) {
    this.language = (this.language === 'es') ? 'en' : 'es';
    console.log(this.language);
    localStorage.setItem("lang", this.language);
    this.imgPath = "../assets/images/" + this.language + "_circle" + ".svg";
    this.translate.use(this.language);
  }

}
